import React from 'react';
import SuperadminLayout from '../../components/SuperadminLayout';
import ReportRunner from '../../components/ReportRunner';

const SuperadminReportsPage = () => (
  <SuperadminLayout>
    <h2 style={{ fontSize: '1.2rem', color: '#1a3f6e', marginBottom: 14 }}>Rapports</h2>
    <ReportRunner showCompanyGroupBy showScopeFilter={false} />
  </SuperadminLayout>
);

export default SuperadminReportsPage;
